import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideSectionLabel,
  GuideLead,
  GuideCallout,
  GuideCompare,
  GuideCard,
  GuideCardGrid,
  GuideContrast,
  GuideBlockList,
} from "../GuideBlocks.js";

const WhatIsMentalClaritySection = ({ heading, accentIndex = 1 }) => (
  <GuidePanel sectionId="what-is-mental-clarity" heading={heading} accentIndex={accentIndex}>
    <GuideSectionLabel>Definition</GuideSectionLabel>
    <GuideLead>
      Mental clarity is the ability to observe situations objectively, separate facts from personal stories,
      regulate emotional reactions, and respond with intention.
    </GuideLead>
    <p className="guide-panel__p">
      A mentally clear person does not eliminate emotions. Instead, they understand their emotions without
      allowing them to control every decision.
    </p>
    <GuideSectionLabel>What clarity allows</GuideSectionLabel>
    <GuideCardGrid columns={3}>
      <GuideCard iconKey="thinking" title="Separate facts from assumptions" />
      <GuideCard iconKey="thinking" title="Respond instead of reacting" />
      <GuideCard iconKey="thinking" title="Think before speaking" />
      <GuideCard iconKey="thinking" title="Decide from evidence, not fear" />
      <GuideCard iconKey="thinking" title="Communicate with precision" />
      <GuideCard iconKey="thinking" title="Stay composed in uncertainty" />
    </GuideCardGrid>
    <GuideSectionLabel>Facts vs. stories</GuideSectionLabel>
    <GuideCompare
      leftTitle="A Simple Fact"
      rightTitle="Emotional Story"
      left={
        <>
          <p>&quot;A colleague did not reply to your email.&quot;</p>
          <p>Objectively, this is a neutral observation. Without structured thinking, the brain fills uncertainty with interpretation.</p>
        </>
      }
      right={
        <GuideBlockList
          items={[
            "They're ignoring me.",
            "They don't respect me.",
            "I've done something wrong.",
          ]}
        />
      }
    />
    <GuideCallout>Mental clarity helps you recognize that the story is not the same as reality.</GuideCallout>
    <GuideSectionLabel>Responding vs. reacting</GuideSectionLabel>
    <GuideContrast
      items={[
        {
          title: "Reaction",
          text: "Automatic. Driven by habit, fear, past experiences, and emotional triggers.",
        },
        {
          title: "Response",
          text: "Intentional. Comes from examined evidence, reflection, and deliberate choice.",
        },
      ]}
    />
    <GuideCallout variant="amber">
      The goal of mental clarity is not to suppress emotions but to create enough space between the event and
      your response.
    </GuideCallout>
  </GuidePanel>
);

export default WhatIsMentalClaritySection;
